import BaseModule from "@core/modules/base-module/base-module";
import SwapBackground from "@core/base/scripts/classes/swap-background/swap-background";
import $ from 'jquery';

// INIT
const peopleList = new BaseModule();
peopleList.name="people-list";
peopleList.init(that => {
  const $images=$("[data-img-default]", that.elements);
      $images.each(function(){
        const swapBackground = new SwapBackground($(this));
        swapBackground.init();
      });
});

